export default "__VITE_ASSET__DlK57hGM__"